module.exports = __webpack_public_path__ + "img/eps.e7a0da49.svg";